import { isEmpty, get } from 'lodash-es';
import {
  TECHNICAL_ERROR_PAGE,
  INELIGIBILE_PAGE,
  CUSTOMER_SEGMENT,
} from 'srcAlias/client/enums/eligibilitySegment';

export const isResponseDataPresent = (response) => {
  return (
    !isEmpty(response) && !isEmpty(response.data) && isEmpty(response.error)
  );
};

const isTechnicalError = (response) =>
  response && response.error !== null && response.data === null;

const isIneligibile = (response) => {
  return (
    !isEmpty(response) &&
    isEmpty(response.error) &&
    get(response, 'data.data.eligibilityType') === 'DECLINE'
  );
};

export const isEligibilityResponsePresent = (response) => {
  return (
    (!isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.data.eligibilityType)) ||
    (!isEmpty(response) && !isEmpty(response.error))
  );
};

export const hasEquityProduct = (response) => {
  return (
    !isEmpty(response) &&
    !isEmpty(
      response.filter(
        (account) =>
          account.accountTypeCode === 'IN6' &&
          account.investmentAccountStatusCode === 'O'
      )
    )
  );
};

export const checkResponse = (
  eligibilityResponse,
  accountListResponse,
  appDataReviewResponse
) => {
  if (
    isTechnicalError(eligibilityResponse) ||
    isTechnicalError(accountListResponse) ||
    isTechnicalError(appDataReviewResponse)
  ) {
    return TECHNICAL_ERROR_PAGE;
  }
  if (
    !isIneligibile(eligibilityResponse) &&
    isResponseDataPresent(eligibilityResponse) &&
    isResponseDataPresent(accountListResponse) &&
    isResponseDataPresent(appDataReviewResponse)
  ) {
    return CUSTOMER_SEGMENT;
  }
  if (isIneligibile(eligibilityResponse)) {
    return INELIGIBILE_PAGE;
  }
  // Always return explicitly
  return undefined;
};
